import { render, staticRenderFns } from "./AgencesNews.vue?vue&type=template&id=308d1d84&"
import script from "./AgencesNews.vue?vue&type=script&lang=js&"
export * from "./AgencesNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports